import React from "react";
import {
    FaBolt,
    FaApple,
    FaShieldAlt,
    FaRocket
} from "react-icons/fa";

const WhyChooseSwift = () => {

    const items = [
        {
            icon: <FaBolt />,
            title: "Blazing Fast Performance",
            desc: "Swift delivers lightning-fast native performance for premium iOS applications.",
        },
        {
            icon: <FaApple />,
            title: "Apple Ecosystem",
            desc: "Seamless integration with iPhone, iPad, Apple Watch and macOS ecosystem.",
        },
        {
            icon: <FaShieldAlt />,
            title: "Secure & Reliable",
            desc: "Swift provides strong type safety and modern security architecture.",
        },
        {
            icon: <FaRocket />,
            title: "Modern Development",
            desc: "Build scalable iOS apps with clean syntax and modern frameworks.",
        },
    ];

    return (
        <>
            <section className="swift-choose">

                {/* BG */}
                <div className="swift-bg-grid"></div>

                <div className="swift-glow glow-1"></div>
                <div className="swift-glow glow-2"></div>

                <div className="swift-container">

                    {/* LEFT CONTENT */}
                    <div className="swift-left">

                        <div className="swift-badge">
                            🍎 Why Choose Swift
                        </div>

                        <h2>
                            Build Powerful
                            <br />
                            <span>Native iOS Apps</span>
                        </h2>

                        <p>
                            Swift empowers businesses with blazing-fast,
                            secure and scalable iOS applications designed
                            for the Apple ecosystem with premium user experiences.
                        </p>

                        {/* FEATURES */}
                        <div className="swift-features">

                            {items.map((item, i) => (

                                <div
                                    className="swift-feature-card"
                                    key={i}
                                >

                                    <div className="swift-icon">
                                        {item.icon}
                                    </div>

                                    <div>

                                        <h3>
                                            {item.title}
                                        </h3>

                                        <p>
                                            {item.desc}
                                        </p>

                                    </div>

                                </div>

                            ))}

                        </div>

                    </div>

                    {/* RIGHT VISUAL */}
                    <div className="swift-right">

                        {/* MAIN CIRCLE */}
                        <div className="swift-circle-wrap">

                            <div className="swift-ring ring-1"></div>
                            <div className="swift-ring ring-2"></div>
                            <div className="swift-ring ring-3"></div>

                            <div className="swift-core">

                                <div className="swift-core-inner">
                                    🍎
                                </div>

                            </div>

                        </div>

                        {/* FLOATING BOXES */}

                        <div className="swift-box box-1">

                            <span>⚡</span>

                            <h4>Fast</h4>

                        </div>

                        <div className="swift-box box-2">

                            <span>🛡️</span>

                            <h4>Secure</h4>

                        </div>

                        <div className="swift-box box-3">

                            <span>🚀</span>

                            <h4>Scalable</h4>

                        </div>

                        <div className="swift-box box-4">

                            <span>🍎</span>

                            <h4>Native</h4>

                        </div>

                    </div>

                </div>

                <style>{`

                .swift-choose{
                    position:relative;
                    overflow:hidden;
                    padding:140px 24px;
                    background:
                    linear-gradient(
                        180deg,
                        #ffffff 0%,
                        #fff5f5 50%,
                        #ffffff 100%
                    );
                }

                .swift-container{
                    max-width:1400px;
                    margin:auto;
                    display:grid;
                    grid-template-columns:1fr 1fr;
                    gap:90px;
                    align-items:center;
                    position:relative;
                    z-index:2;
                }

                /* GRID */

                .swift-bg-grid{
                    position:absolute;
                    inset:0;

                    background-image:
                    linear-gradient(
                        rgba(0,0,0,.03) 1px,
                        transparent 1px
                    ),
                    linear-gradient(
                        90deg,
                        rgba(0,0,0,.03) 1px,
                        transparent 1px
                    );

                    background-size:70px 70px;

                    mask-image:
                    radial-gradient(
                        circle at center,
                        black,
                        transparent 90%
                    );
                }

                /* GLOW */

                .swift-glow{
                    position:absolute;
                    border-radius:50%;
                    filter:blur(120px);
                    opacity:.14;
                }

                .glow-1{
                    width:420px;
                    height:420px;
                    background:#E8212A;
                    top:-120px;
                    left:-120px;
                    animation:glowMove1 10s infinite ease-in-out;
                }

                .glow-2{
                    width:380px;
                    height:380px;
                    background:#FF4D4D;
                    bottom:-140px;
                    right:-100px;
                    animation:glowMove2 12s infinite ease-in-out;
                }

                /* LEFT */

                .swift-badge{
                    display:inline-flex;
                    align-items:center;
                    gap:10px;
                    padding:12px 24px;
                    border-radius:999px;

                    background:rgba(232,33,42,.08);

                    border:1px solid rgba(232,33,42,.14);

                    color:#E8212A;

                    font-size:13px;
                    font-weight:700;
                    letter-spacing:1px;

                    margin-bottom:28px;

                    font-family:'Plus Jakarta Sans',sans-serif;

                    animation:pulse 3s infinite;
                }

                .swift-left h2{
             font-size: clamp(35px, 6vw, 54px);
    line-height: .95;
    margin: 0 0 24px;
    color: #111;
    /* font-weight: 900; */
    letter-spacing: -4px;
    font-family: 'Syne', sans-serif;
                }

                .swift-left h2 span{
                    color:#E8212A;
                }

                .swift-left > p{
                    color:#666;
                    font-size:18px;
                    line-height:1.9;
                    max-width:680px;
                    margin-bottom:50px;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                /* FEATURE CARDS */

                .swift-features{
                    display:grid;
                    gap:24px;
                }

                .swift-feature-card{
                    display:flex;
                    gap:22px;
                    align-items:flex-start;

                    padding:26px;

                    border-radius:28px;

                    background:#fff;

                    border:1px solid #f2f2f2;

                    box-shadow:
                    0 18px 50px rgba(0,0,0,.05);

                    transition:.45s ease;

                    position:relative;
                    overflow:hidden;
                }

                .swift-feature-card::before{
                    content:"";
                    position:absolute;
                    inset:0;

                    background:
                    linear-gradient(
                        135deg,
                        rgba(232,33,42,.08),
                        transparent 60%
                    );

                    opacity:0;
                    transition:.4s ease;
                }

                .swift-feature-card:hover{
                    transform:translateY(-10px);
                    border-color:rgba(232,33,42,.18);

                    box-shadow:
                    0 30px 70px rgba(232,33,42,.12);
                }

                .swift-feature-card:hover::before{
                    opacity:1;
                }

                .swift-icon{
                    width:78px;
                    height:78px;
                    min-width:78px;

                    border-radius:24px;

                    display:flex;
                    align-items:center;
                    justify-content:center;

                    font-size:34px;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    color:#fff;

                    box-shadow:
                    0 15px 40px rgba(232,33,42,.22);

                    animation:floatIcon 4s infinite ease-in-out;
                }

                .swift-feature-card h3{
                    margin:0 0 10px;
                    color:#111;
                    font-size:28px;
                    line-height:1.1;
               
                    letter-spacing:-1px;
                    font-family:'Syne',sans-serif;
                }

                .swift-feature-card p{
                    color:#666;
                    line-height:1.8;
                    font-size:15px;
                    margin:0;
                    font-family:'Plus Jakarta Sans',sans-serif;
                }

                /* RIGHT */

                .swift-right{
                    position:relative;
                    height:760px;
                    display:flex;
                    align-items:center;
                    justify-content:center;
                }

                /* CIRCLE */

                .swift-circle-wrap{
                    position:relative;
                    width:620px;
                    height:620px;

                    display:flex;
                    align-items:center;
                    justify-content:center;
                }

                .swift-ring{
                    position:absolute;
                    border-radius:50%;
                    border:1px dashed rgba(232,33,42,.18);
                    animation:ringRotate linear infinite;
                }

                .ring-1{
                    width:260px;
                    height:260px;
                    animation-duration:18s;
                }

                .ring-2{
                    width:420px;
                    height:420px;
                    animation-duration:26s;
                    animation-direction:reverse;
                }

                .ring-3{
                    width:580px;
                    height:580px;
                    animation-duration:34s;
                }

                .swift-core{
                    width:220px;
                    height:220px;
                    border-radius:50%;

                    padding:12px;

                    background:
                    linear-gradient(
                        135deg,
                        #E8212A,
                        #FF4D4D
                    );

                    box-shadow:
                    0 30px 90px rgba(232,33,42,.25);

                    animation:coreFloat 5s infinite ease-in-out;

                    z-index:2;
                }

                .swift-core-inner{
                    width:100%;
                    height:100%;
                    border-radius:50%;

                    background:#fff;

                    display:flex;
                    align-items:center;
                    justify-content:center;

                    font-size:80px;
                }

                /* FLOAT BOX */

                .swift-box{
                    position:absolute;

                    width:140px;
                    height:140px;

                    border-radius:32px;

                    background:#fff;

                    border:1px solid #f1f1f1;

                    display:flex;
                    flex-direction:column;
                    align-items:center;
                    justify-content:center;

                    gap:10px;

                    box-shadow:
                    0 20px 60px rgba(0,0,0,.06);

                    animation:floatBox 5s infinite ease-in-out;
                }

                .swift-box span{
                    font-size:38px;
                }

                .swift-box h4{
                    margin:0;
                    color:#111;
                    font-size:22px;
                    font-family:'Syne',sans-serif;
                }

                .box-1{
                    top:60px;
                    left:120px;
                }

                .box-2{
                    top:120px;
                    right:90px;
                    animation-delay:1s;
                }

                .box-3{
                    bottom:80px;
                    right:120px;
                    animation-delay:2s;
                }

                .box-4{
                    bottom:100px;
                    left:90px;
                    animation-delay:3s;
                }

                /* ANIMATION */

                @keyframes ringRotate{
                    from{
                        transform:rotate(0deg);
                    }
                    to{
                        transform:rotate(360deg);
                    }
                }

                @keyframes floatBox{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-14px);
                    }
                }

                @keyframes coreFloat{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-16px);
                    }
                }

                @keyframes floatIcon{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-8px);
                    }
                }

                @keyframes pulse{
                    0%,100%{
                        transform:scale(1);
                    }
                    50%{
                        transform:scale(1.05);
                    }
                }

                @keyframes glowMove1{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(60px);
                    }
                }

                @keyframes glowMove2{
                    0%,100%{
                        transform:translateY(0);
                    }
                    50%{
                        transform:translateY(-60px);
                    }
                }

                /* RESPONSIVE */

                @media(max-width:1100px){

                    .swift-container{
                        grid-template-columns:1fr;
                    }

                    .swift-right{
                        height:700px;
                    }

                }

                @media(max-width:768px){

                    .swift-choose{
                        padding:100px 18px;
                    }

                    .swift-left h2{
                        letter-spacing:-2px;
                    }

                    .swift-circle-wrap{
                        width:380px;
                        height:380px;
                    }

                    .ring-1{
                        width:180px;
                        height:180px;
                    }

                    .ring-2{
                        width:280px;
                        height:280px;
                    }

                    .ring-3{
                        width:380px;
                        height:380px;
                    }

                    .swift-core{
                        width:160px;
                        height:160px;
                    }

                    .swift-core-inner{
                        font-size:60px;
                    }

                    .swift-box{
                        width:110px;
                        height:110px;
                    }

                    .swift-box h4{
                        font-size:16px;
                    }

                    .box-1{
                        left:10px;
                    }

                    .box-2{
                        right:10px;
                    }

                    .box-3{
                        right:20px;
                    }

                    .box-4{
                        left:20px;
                    }

                    .swift-feature-card{
                        flex-direction:column;
                    }

                }

            `}</style>

            </section>
        </>
    );
};

export default WhyChooseSwift;